export const isServerSide = () => typeof window === 'undefined' && typeof process !== 'undefined';
//# sourceMappingURL=isServerSide.js.map